import _ from 'lodash';

const defaultState = {
  clients: [],
  renewals: [],
  schedules: [],
  masterPerReportFeeVal: null,
  directProducts: { currency: null, products: [] },
  pendingContracts: {},
  lastCreate: null,
  loading: {},
  error: null,
};

const consultantClientsReducers = (state, action) => {
  const newState = _.cloneDeep(state);

  switch (action.type) {
    case 'CONSULTANT_CLIENTS_SET':
      newState.consultantClients = {
        ...(newState.consultantClients || defaultState),
        clients: action.payload || [],
        error: null,
      };
      return newState;

    case 'CONSULTANT_CLIENTS_RENEWALS':
      newState.consultantClients = {
        ...(newState.consultantClients || defaultState),
        renewals: action.payload || [],
      };
      return newState;

    case 'CONSULTANT_CLIENTS_SCHEDULES':
      newState.consultantClients = {
        ...(newState.consultantClients || defaultState),
        schedules: action.payload?.schedules || [],
        masterPerReportFeeVal: action.payload?.masterPerReportFeeVal ?? null,
      };
      return newState;

    case 'CONSULTANT_CLIENTS_DIRECT_PRODUCTS':
      newState.consultantClients = {
        ...(newState.consultantClients || defaultState),
        directProducts: action.payload || { currency: null, products: [] },
      };
      return newState;

    case 'CONSULTANT_CLIENTS_PENDING_CONTRACTS': {
      const incoming = action.payload || {};
      const pendingContracts = { ...(newState.consultantClients?.pendingContracts || {}) };
      if (action.remove) {
        Object.keys(incoming).forEach((orgId) => {
          if (incoming[orgId] == null) delete pendingContracts[orgId];
        });
      } else {
        Object.assign(pendingContracts, incoming);
      }
      newState.consultantClients = {
        ...(newState.consultantClients || defaultState),
        pendingContracts,
      };
      return newState;
    }

    case 'CONSULTANT_CLIENTS_LAST_CREATE':
      newState.consultantClients = {
        ...(newState.consultantClients || defaultState),
        lastCreate: action.payload,
      };
      return newState;

    case 'CONSULTANT_CLIENTS_LOADING': {
      const loading = { ...(newState.consultantClients?.loading || {}) };
      if (action.value) loading[action.key] = true;
      else delete loading[action.key];
      newState.consultantClients = {
        ...(newState.consultantClients || defaultState),
        loading,
      };
      return newState;
    }

    case 'CONSULTANT_CLIENTS_ERROR':
      newState.consultantClients = {
        ...(newState.consultantClients || defaultState),
        error: action.error,
      };
      return newState;

    default:
      return state;
  }
};

export default consultantClientsReducers;
